<div class="sx-registration-pane" *ngIf="noCustomerRegistered || isWhiteLabel">
    <!-- Ej Förvaltare - inga kunder  -->
    <app-system-message *ngIf="!isManger && !isWhiteLabel" 
        [isVisible]="true" 
        [isDismissable]="false" 
        [severity]="2">
        <span>{{ 'registration.no_customer_message' | translate}}</span>
        <a href="#" [routerLink]="['/secure/register/additional']">
            {{'registration.no_customer_link'| translate}}
        </a>{{'registration.no_customer_link_text'|translate}}
    </app-system-message>

    <!-- Förvaltare - inga förvaltarbolag   -->
    <app-system-message *ngIf="isManger && !isWhiteLabel && noOfManagerCompanies === 0" 
        [isVisible]="true" 
        [isDismissable]="false" 
        [severity]="2" >
        <span>{{ 'registration.no_manager_company_message' | translate}}</span>
        <a  href="javascript:void(0)" (click)="navigateToManagerAdmin()">
            {{ 'registration.no_customer_link' | translate}}
        </a>{{ 'registration.no_customer_link_text' | translate}}
    </app-system-message>

    <!-- Förvaltare - inga kunder   -->
    <app-system-message *ngIf="isManger && !isWhiteLabel && noOfManagerCompanies > 0" 
        [isVisible]="true"
        [isDismissable]="false" 
        [severity]="2" >
        <span>{{ 'registration.no_customer_message' | translate}}</span>
        <span>
            <a href="javascript:void(0)" (click)="navigateToManagerAdmin()">
                {{'registration.no_customer_link'|translate}}
            </a>{{'registration.no_customer_link_text'|translate}}
        </span>
    </app-system-message>
</div>

<!-- Ej Förvaltare - har kunder men inga anläggningar -->
<div class="sx-registration-pane" *ngIf="!noCustomerRegistered && noMeteringPointOnRegisteredCustomers">
    <app-system-message 
        [isVisible]="true" 
        [isDismissable]="false" 
        [severity]="2" >
        <span>{{ 'registration.no_meteringpoints_message' | translate }}</span>
        <span>
            <a href="javascript:void(0)" (click)="openSupportPage()">
                {{'registration.no_metering_point_link'|translate}}
            </a>{{'registration.no_metering_point_link_text'|translate}}
        </span>
    </app-system-message>
</div>

<!-- Förvaltare - har kunder men inga anläggningar -->
<div class="sx-registration-pane" *ngIf="!noCustomerRegistered && noAccessToMeteringPoints && isManger">
    <app-system-message 
        [isVisible]="true" 
        [isDismissable]="false" 
        [severity]="2" >
        <span>{{ 'registration.no_access_message' | translate}}</span>
        <a *ngIf="isManger" href="javascript:void(0)" (click)="navigateToManagerAdmin()">
            {{ 'registration.no_access_link' | translate}}
        </a>
    </app-system-message>
</div>
